<template>
  <div class="comment-wrapper">
    <div class="comment-item" v-for="item in commentList" :key="item.id">
      <img :src="item.publicImage" alt="" />
      <div class="item-right">
        <span class="item-nickname">{{ item.nickname }}</span>
        <span class="item-date">{{ item.publishDate }}</span>
        <div class="item-content" v-html="useContentEmotion(item.content)"></div>
      </div>
      <div class="thumbs-wrapper">
        <i class="v-icon-like" />
        <span>{{ item.praiseSum }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import emotionList from "@/assets/js/emotion.js";

export default defineComponent({
  name: "Comment",
  props: {
    commentList: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  setup() {
    const _emotionList = emotionList;

    // 转换emoji表情
    const useContentEmotion = str => {
      let tmp = "";
      let resultStr = "";
      const stack = [];

      for (const item of str) {
        if (item === "[") {
          stack.push(item);
        }
        if (stack.length) {
          stack.push(item);
          if (item === "]") {
            let emotion = stack.join("").slice(1);
            _emotionList.forEach(item => {
              if (item.text === emotion) {
                let imgSrc = require(`@/assets/image/emotion/${item.name}.png`);
                tmp += `<img style="width: 22px; height: 22px; transform: translateY(5px);" src="${imgSrc}" />`;
              }
            });
            stack.length = 0;
          }
        } else {
          tmp += item;
        }
      }
      resultStr = tmp;

      return `<span style="line-height: 22px; color: #111;">${resultStr}</span>`;
    };

    return {
      useContentEmotion
    };
  }
});
</script>

<style lang="scss" scoped>
.comment-wrapper {
  width: 100%;

  .comment-item {
    position: relative;
    display: flex;
    box-sizing: border-box;
    padding-bottom: 20px;

    & > img {
      width: 45px;
      height: 45px;
      border-radius: 50%;
      overflow: hidden;
      flex-shrink: 0;
      margin-right: 10px;
    }

    .item-right {
      display: flex;
      flex-direction: column;

      .item-nickname {
        font-size: 16px;
        color: #111;
        font-weight: bold;
      }

      .item-date {
        display: inline-block;
        font-size: 14px;
        color: #666;
        margin-top: 8px;
      }

      .item-content {
        font-size: 16px;
        margin-top: 5px;
      }
    }

    .thumbs-wrapper {
      position: absolute;
      top: 0;
      right: 0;
      display: flex;
      align-items: center;
      color: #111;

      .v-icon-like {
        margin-right: 5px;
      }
    }
  }
}
</style>
